/* eslint-disable no-underscore-dangle */
const UIProductInnerElement = require('./productInnerElement');

/** Product item component */
/** @param {HTMLElement} element */
function UIProductItem(element) {
  let innerElement;
  const sameHeightElementsSelectors = [
    '.countdownLabels',
    '.product-images',
    '.badges',
    '.productBundle',
    '.reevoo-placeholder',
    '.promoMessages',
    '.productDescription',
    '.productPrices',
    '.channels-availability',
    '.countdownMessage',
    '.product-desc',
    '.online-credit-message-wrapper',
    '.alternative-tariff-link-wrapper'
  ];

  this.__element = element;
  this.__innerComponents = [];

  for (let i = 0, len = sameHeightElementsSelectors.length; i < len; i++) {
    innerElement = this.__element.querySelector(sameHeightElementsSelectors[i]);
    if (innerElement) {
      this.__innerComponents.push(new UIProductInnerElement(innerElement));
    }
  }
}

/**
 * Returns self as HTML element
 * @returns {element}
 */
UIProductItem.prototype.getElement = function getElement() {
  return this.__element;
};

/**
 * Gets the id of the product
 * @returns {string}
 */
UIProductItem.prototype.getId = function getId() {
  return this.__element.id;
};

/**
 * Gets the width of the product
 * @returns {int}
 */
UIProductItem.prototype.getWidth = function getWidth() {
  return this.__element.offsetWidth;
};

/**
 * Gets the height of the product
 * @returns {int}
 */
UIProductItem.prototype.getHeight = function getHeight() {
  this.setHeight('auto');
  return this.__element.offsetHeight;
};

/**
 * Sets the height of product
 * @param {int|string} height
 */
UIProductItem.prototype.setHeight = function setHeight(height) {
  this.__element.style.height = height + (typeof height === 'string' ? '' : 'px');
};

/**
 * Gets the inner components
 * @returns {Array}
 */
UIProductItem.prototype.getInnerComponents = function getInnerComponents() {
  return this.__innerComponents;
};

UIProductItem.prototype.hide = function hide() {
  this.__element.style.display = 'none';
};

UIProductItem.prototype.show = function show() {
  this.__element.style.display = 'block';
};

UIProductItem.prototype.isVisible = function visible() {
  return this.__element.style.display !== 'none';
};

module.exports = UIProductItem;
